function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicRing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.902522mm",
    height: "11.374177mm",
    viewBox: "0 0 10.902522 11.374177",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.467797,-2.4044961)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.154182,-3.5546847)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 51.098593,16.833358 c -2.901741,-0.397563 -4.976614,-2.612753 -4.976614,-5.374177 0,-2.7614238 2.238576,-5.0000002 5,-5.0000002 2.761424,0 5.357109,2.3460439 4.836297,5.1870892 -0.520812,2.841045 -3.353769,3.598826 -5.023386,3.140316 -1.669616,-0.458509 -2.812911,-1.670551 -2.812911,-3.327405 0,-1.6568543 1.343146,-3.0000002 3,-3.0000002 1.656854,0 2.941535,0.9455825 2.859684,3.0584662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicRing2);
export default __webpack_public_path__ + "static/media/magic-ring-2.21ec9046893ce6742d619152514b4a0e.svg";
export { ForwardRef as ReactComponent };